import React from "react";
import i18n from "../../../i18n";
import { Card, Callout, Spinner } from "@blueprintjs/core";
import { Trans } from "react-i18next";

import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import { Chart } from "chart.js";
import "chartjs-adapter-date-fns";
import { generic_colors } from "../../Charts/Colors";

export class UserTypeRepartitionEntry extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      labels: [],
      loading: false,
    };
    this.canvasRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.urlsearchparams !== undefined) {
      this.setState({ loading: true }, () => {
        authenticatedGetFetch(
          "/activity/usertypeentrydistribution?" + this.props.urlsearchparams,
          (res) => {
            this.setState(
              {
                data: res["data"],
                labels: res["periods"],
                loading: false,
              },
              () => {
                const datasets = [];
                for (let i = 0; i < this.state.data.length; i++) {
                  if (
                    this.state.data[i] !== undefined &&
                    this.state.data[i] !== null
                  ) {
                    datasets.push({
                      label: i18n.t("userType" + i),
                      data: this.state.data[i],
                      fill: "none",
                      backgroundColor: generic_colors[i],
                      pointRadius:
                        this.props.points === undefined ||
                        this.props.points === true
                          ? 3
                          : 1,
                      borderColor: generic_colors[i],
                      borderWidth: 1,
                      lineTension: 0.3,
                    });
                  }
                }
                if (datasets.length > 0) {
                  if (this.myChart === undefined) {
                    this.myChart = new Chart(this.canvasRef.current, {
                      type: "bar",
                      options: {
                        responsive: true,
                        maintainAspectRatio: true,
                        scales: {
                          yAxes: {
                            stacked: true,
                            ticks: {
                              min: 0,
                            },
                          },
                          xAxes: { stacked: true },
                        },
                        interaction: {
                          intersect: false,
                          mode: "index",
                        },
                      },
                      data: {
                        labels: this.state.labels,
                        datasets: datasets,
                      },
                    });
                  } else this.myChart.update();
                }
              }
            );
          }
        );
      });
    }
  }

  render() {
    if (this.props.urlsearchparams !== undefined)
      return (
        <Callout icon="log-out" title={<Trans>parking entries</Trans>}>
          {this.state.loading ? (
            <Spinner />
          ) : (
            <div className="flexbox-center">
              {this.state.data !== undefined && this.state.data.length > 0 ? (
                <Card className="medium-chart-container">
                  <canvas ref={this.canvasRef} />
                </Card>
              ) : (
                <Callout intent="warning">
                  <Trans>no data for the period</Trans>
                </Callout>
              )}
              <Callout intent="primary">
                <Trans>
                  based on the entry events of different types of users
                </Trans>
              </Callout>
            </div>
          )}
        </Callout>
      );
    else return null;
  }
}

export class UserTypeRepartitionExit extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      labels: [],
      loading: false,
    };
    this.canvasRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.urlsearchparams !== undefined) {
      this.setState({ loading: true }, () => {
        authenticatedGetFetch(
          "/activity/usertypeexitdistribution?" + this.props.urlsearchparams,
          (res) => {
            this.setState(
              {
                data: res["data"],
                labels: res["periods"],
                loading: false,
              },
              () => {
                const datasets = [];
                for (let i = 0; i < this.state.data.length; i++) {
                  if (
                    this.state.data[i] !== undefined &&
                    this.state.data[i] !== null
                  ) {
                    datasets.push({
                      label: i18n.t("userType" + i),
                      data: this.state.data[i],
                      fill: "none",
                      backgroundColor: generic_colors[i],
                      pointRadius:
                        this.props.points === undefined ||
                        this.props.points === true
                          ? 3
                          : 1,
                      borderColor: generic_colors[i],
                      borderWidth: 1,
                      lineTension: 0.3,
                    });
                  }
                }
                if (datasets.length > 0) {
                  if (this.myChart === undefined) {
                    this.myChart = new Chart(this.canvasRef.current, {
                      type: "bar",
                      options: {
                        responsive: true,
                        maintainAspectRatio: true,
                        scales: {
                          yAxes: {
                            stacked: true,
                            ticks: {
                              min: 0,
                            },
                          },
                          xAxes: { stacked: true },
                        },
                        interaction: {
                          intersect: false,
                          mode: "index",
                        },
                      },
                      data: {
                        labels: this.state.labels,
                        datasets: datasets,
                      },
                    });
                  } else this.myChart.update();
                }
              }
            );
          }
        );
      });
    }
  }

  render() {
    if (this.props.urlsearchparams !== undefined)
      return (
        <Callout icon="log-out" title={<Trans>parking exits</Trans>}>
          {this.state.loading ? (
            <Spinner />
          ) : (
            <div className="flexbox-center">
              {this.state.data !== undefined && this.state.data.length > 0 ? (
                <Card className="medium-chart-container">
                  <canvas ref={this.canvasRef} />
                </Card>
              ) : (
                <Callout intent="warning">
                  <Trans>no data for the period</Trans>
                </Callout>
              )}
              <Callout intent="primary">
                <Trans>
                  based on the exit events of different types of users
                </Trans>
              </Callout>
            </div>
          )}
        </Callout>
      );
    else return null;
  }
}
